export class UserFacingError extends Error {
  titleKey = 'global.error_title'
  messageKey = 'global.error_message'

  constructor(titleKey: string, messageKey: string) {
    super()
    this.titleKey = titleKey
    this.messageKey = messageKey
  }
}

export class MfaRequiredError extends Error {
  recipient: string
  channel: string

  constructor(channel: string, recipient: string) {
    super('missing_authentication_code')
    this.recipient = recipient
    this.channel = channel
  }
}

export class FailedAuthenticationError extends Error {}
export class TooManyAttemptsError extends Error {}

export const enum ErrorCodes {
  EXPIRED_SESSION = 'EXPIRED_SESSION',
  INVALID_GRANT = 'invalid_grant',
  MISSING_AUTHENTICATION_CODE = 'missing_authentication_code',
  RECAPTCHA_INVALID_TOKEN = 'RECAPTCHA_INVALID_TOKEN',
  INVALID_TWO_STEP_VERIFICATION_CODE = 'invalid_two_step_verification_code',
}
